export default __webpack_public_path__ + "static/media/28mm blue cap.3d49b767.jpeg";